// extracted by mini-css-extract-plugin
export default {"Fill":"BackgroundStylesTray_Fill__RHTZR","Border":"BackgroundStylesTray_Border__E+Yd6","Shadow":"BackgroundStylesTray_Shadow__fXGBP"};